import { NgModule, ErrorHandler } from "@angular/core";
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
} from "@angular/platform-browser";
import { IonicApp, IonicModule, IonicErrorHandler } from "ionic-angular";
import { MyApp } from "./app.component";
import { StatusBar } from "@ionic-native/status-bar";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { LocalStorageService } from "../services/localStorage.service";
import { API } from "../services/api";
import { Network } from "@ionic-native/network";
import { MessagePresenter } from "../services/message.service";
import { ConnectivityChecker } from "../services/connectivity.service";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { File } from "@ionic-native/file";
import { DataService } from "../services/data.service";
import { ScreenOrientation } from "@ionic-native/screen-orientation";
import { AppVersion } from "@ionic-native/app-version";
import { Market } from "@ionic-native/market";
import { CheckVersion } from "../services/checkVersion";
import { IonicStorageModule } from "@ionic/storage";
import { SocialSharing } from "@ionic-native/social-sharing";
import { FileOpener } from "@ionic-native/file-opener";
import { HTTP } from "@ionic-native/http";
import { Keyboard } from "@ionic-native/keyboard";
import { Firebase } from "@ionic-native/firebase";
import { DataProvider } from "../providers/data";
import * as ionicGalleryModal from "ionic-gallery-modal";
import { AngularFireModule, FirebaseOptionsToken } from "@angular/fire";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { ChatService } from "../services/chat.service";
import { Europass } from "../services/europass";
import { IonicImageLoader } from "ionic-image-loader";
import { FeatureFlags } from "../services/featureFlags";
import { EmailComposer } from "@ionic-native/email-composer";
import { AppAvailability } from "@ionic-native/app-availability";
import { FirebaseConfig } from "../services/firebaseConfig";
import { FileTransfer, FileTransferObject } from "@ionic-native/file-transfer";
import { SplashScreen } from "@ionic-native/splash-screen";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import { CallNumber } from "@ionic-native/call-number";
import { CacheModule } from "ionic-cache";
import { DateAndTime } from "../services/dateAndTime.service";
import { InitAppService } from "../services/initApp.service";
import { Utils } from "../services/Utils";
import { Settings } from "../services/settings.service";
import { FilterNewsPageModule } from "../modals/filter-news/filter-news.module";
import {} from "../modals/calendar-work-historical/calendar-work-historical";
import { NotificationsService } from "../services/notifications.service";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
export const nameStorage = "Laberit";
export const environment = "laberit";
export function initializeApp(appConfig: FirebaseConfig) {
  return appConfig[environment];
}

@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    HttpClientModule,
    ionicGalleryModal.GalleryModalModule,
    FilterNewsPageModule,
    IonicStorageModule.forRoot({
      name: nameStorage,
      driverOrder: ["sqlite", "localstorage", "indexeddb", "websql"],
    }),
    IonicModule.forRoot(MyApp, {
      scrollAssist: false,
      autoFocusAssist: false,
      backButtonText: "",
      tabsHideOnSubPages: true,
      pageTransition: "ios-transition",
    }),
    AngularFireModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    IonicImageLoader.forRoot(),
    CacheModule.forRoot({ keyPrefix: "fuifi-cache" }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    StatusBar,
    BarcodeScanner,
    LocalStorageService,
    MessagePresenter,
    ConnectivityChecker,
    NotificationsService,
    API,
    Utils,
    Settings,
    Network,
    Firebase,
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: ionicGalleryModal.GalleryModalHammerConfig,
    },
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    InAppBrowser,
    DataService,
    File,
    ScreenOrientation,
    AppVersion,
    Market,
    CheckVersion,
    SocialSharing,
    FileOpener,
    EmailComposer,
    HTTP,
    Keyboard,
    FirebaseConfig,
    {
      provide: FirebaseOptionsToken,
      deps: [FirebaseConfig],
      useFactory: initializeApp,
    },
    DataProvider,
    ChatService,
    Europass,
    FeatureFlags,
    AppAvailability,
    FileTransfer,
    FileTransferObject,
    SplashScreen,
    CallNumber,
    DateAndTime,
    InitAppService,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts